import api from '@pray/shared/utils/api';

import type { CreateExperimentParams } from './types/app';

/**
 * Creates a new experiment
 * @param name - The name of the experiment
 * @param instance - The instance of the experiment
 * @param control - The control of the experiment
 * @param variations - The variations of the experiment
 */
export async function createExperiment({ name, instance, control, variations }: CreateExperimentParams) {
  if (!name) throw new Error('Name is required');
  if (!instance) throw new Error('Instance is required');
  if (!control) throw new Error('Control is required');
  if (!variations) throw new Error('Variations are required');

  const body = {
    name,
    instance,
    control,
    variations,
  };

  const url = '/web/studio/experiments';

  await api.executePostRequest<void>(url, body);
}
